var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exercise u-padding-bottom-huge"},[_c('exerciseHeader',{attrs:{"withCancel":"true"},on:{"cancel":function($event){return _vm.cancel()},"close":function($event){return _vm.close()}}}),_c('exerciseEdit',{attrs:{"mode":"admin"},on:{"close":function($event){return _vm.close()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }